import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function LostReasonSection({ formData, handleChange }) {
  if (formData.status !== 'closed_lost') return null;

  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-semibold text-red-700 mb-4">Closed - Lost Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label>Lost Reason *</Label>
          <select name="lost_reason" value={formData.lost_reason} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-red-200 bg-white px-3 text-sm" data-testid="lead-lost-reason" required>
            <option value="">Select Reason</option>
            <option value="budget_mismatch">Budget Mismatch</option>
            <option value="competitor">Purchased from Competitor</option>
            <option value="location_mismatch">Location Mismatch</option>
            <option value="postponed">Purchase Postponed</option>
            <option value="not_reachable">Client Not Reachable</option>
            <option value="decision_changed">Decision Changed</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <Label>Additional Notes</Label>
          <Input name="lost_notes" value={formData.lost_notes} onChange={handleChange} placeholder="Details about why the lead was lost" className="mt-1 h-11 rounded-sm" />
        </div>
      </div>
    </div>
  );
}
